<template>
  <div class="row" id="my-container">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <template v-if="!isMobile">
            <Sidepanel @onDriverSelected="onDriverSelected"/>
          </template>

          <template v-else>

            <b-card class="mb-3">

              <div
                  class="d-flex justify-content-between align-items-center"
              >
                <div>
                  <h5 class="mb-1">Drivers</h5>

                  <small class="text-muted">
                    {{ driverList.length }} selected
                  </small>
                </div>

                <b-button
                    size="sm"
                    variant="primary"
                    @click="showDriverModal = true"
                >
                  <i class="fa fa-users mr-1"></i>
                  Select
                </b-button>

              </div>

              <div
                  v-if="driverList.length"
                  class="selected-driver-chips mt-3"
              >

      <span
          v-for="driver in driverList.slice(0,3)"
          :key="driver.id"
          class="badge badge-pill badge-primary mr-2 mb-2 p-2"
      >
        {{ driver.name }}
      </span>

                <span
                    v-if="driverList.length>3"
                    class="badge badge-pill badge-light p-2"
                >
        +{{ driverList.length - 3 }} more
      </span>

              </div>

            </b-card>

          </template>
          <div class="inbox-rightbar">
            <!--              <Toolbar />-->
            <template>
              <div v-if="!isMobile">
                <div class="mt-0">
                  <h5 @click="toggleCollapse" style="cursor:pointer;">Drivers ({{ driverList.length }})</h5>

                  <div class="row">
                    <div v-for="(driver, index) in visibleDrivers" :key="index" class="col-md-3">
                      <div class="card">
                        <div class="p-1">
                          <div class="d-flex align-items-center" style="cursor:pointer;">
                            <!-- Avatar -->
                            <b-avatar size="md" variant="dark" class="text-light">
                              <span>{{ driver.name | initials }}</span>
                            </b-avatar>

                            <!-- Driver Information -->
                            <div class="ml-3">
                              <h5 class="font-14 mb-1 line-ellipsis">{{ driver.name }} {{ driver.other_names }}</h5>
                              <div><span class="badge badge-success">{{ driver.driver.dossier }}</span></div>
                              <h6>{{ driver.prospective_driver.service_type | serviceType }}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Show 'Show More' or 'Show Less' button -->
                  <div v-if="driverList.length > visibleDriversCount">
                    <button class="btn btn-link" @click="toggleCollapse">
                      {{ isCollapsed ? 'Show More' : 'Show Less' }}
                    </button>
                  </div>
                </div>
                <hr>
              </div>

              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Filter By</label>
                    <select class="form-control" v-model="selectedOption" @change="selectFilterCard">
                      <option value="filter-by-date-range">Date Range</option>
                      <option value="filter-by-weeks">Weeks</option>
                      <option value="filter-by-periods">Periods, Yearly, Quarterly</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6" v-if="selectedOption==='filter-by-date-range'">
                  <div class="form-group">
                    <label>Select date</label>
                    <date-picker v-model="date_range" valueType="format" @clear='removeDate'
                                 @change="dateRangeChanged" range append-to-body lang="en" confirm></date-picker>
                  </div>
                </div>

                <div class="col-md-3 col-6" v-if="selectedOption==='filter-by-weeks'">
                  <div class="form-group">
                    <label>From</label>
                    <input type="week" class="form-control" v-model="startWeek" @change="weekChanged">
                  </div>
                </div>

                <div class="col-md-3 col-6" v-if="selectedOption==='filter-by-weeks'">
                  <div class="form-group">
                    <label>To</label>
                    <input type="week" class="form-control" v-model="endWeek" @change="weekChanged">
                  </div>
                </div>

              </div>

              <b-card v-if="selectedOption==='filter-by-periods'">
                <h4 class="card-title">Filter by periods, yearly, quarterly</h4>
                <div class="row">
                  <div class="col-md-2 col-4">
                    <select class="form-control mr-2" v-model="selectedYear">
                      <option :value="ys" v-for="ys in years">{{ ys }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-8">
                    <select class="form-control mr-2" v-model="filterSelected" @change="onFilterPeriodsChanged">
                      <option v-for="option in filterOptions" :value="option.value"> {{ option.text }}</option>
                    </select>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6">
                    <label class="mt-2">Selected periods</label>
                    <b-form-tags
                        input-id="tags-pills"
                        v-model="periods"
                        tag-variant="primary"
                        class="mr-2"
                        tag-pills
                        :tag-validator="periodTagValidator"
                        size="lg"
                        separator=" "
                        placeholder="Enter period numbers (1–12), e.g. 1 2 3, then press Enter"
                    ></b-form-tags>
                  </div>
                  <div class="col-md-3">
                    <label class="mt-2">Download Option</label>
                    <select class="form-control" v-model="downloadOption">
                      <option value="single"> Single Periods</option>
                      <option value="merge"> Merge Periods</option>
                    </select>
                  </div>
                </div>

              </b-card>

              <b-card>
                <h4 class="card-title">Actions</h4>
                <button class="btn btn-dark mr-4" @click="generateFinancialSheet">
                  <i class="fa fa-file-download mr-1"></i>
                  Generate Financial Sheet
                </button>

                <b-dropdown right variant="info">
                  <template #button-content>
                    <i class="fa fa-file-download mr-1"></i>
                    Export Financials
                  </template>

                  <b-dropdown-item @click="downloadFinancialSheetForDriver('csv')">
                    CSV
                  </b-dropdown-item>

                  <b-dropdown-divider/>

                  <b-dropdown-item @click="downloadFinancialSheetForDriver('pdf')">
                    PDF
                  </b-dropdown-item>
                </b-dropdown>
              </b-card>


              <b-card>
                <h4 class="card-title">Generated Financial Sheets </h4>
                <small class="text-danger">(Links are available to 30 mins for security purposes)</small>
                <table class="table table-bordered table-hover table-responsive">
                  <thead>
                  <tr>
                    <th class="cursor-pointer">Job ID</th>
                    <th class="cursor-pointer">Status</th>
                    <th class="cursor-pointer">Period</th>
                    <th class="cursor-pointer">Time taken</th>
                    <th class="cursor-pointer">Details</th>
                    <th class="cursor-pointer">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(job, index) in jobs" :key="index">
                    <td>{{ job.id }}</td>
                    <td>{{ job.status }}</td>
                    <td v-if="job.option ==='filter-by-date-range'">
                      {{ job.date_range[0] }}
                      -
                      {{ job.date_range[1] }}
                    </td>

                    <td v-if="job.option ==='filter-by-weeks'">
                      {{ job.start_date }}
                      -
                      {{ job.end_date }}
                    </td>

                    <td v-if="job.option ==='filter-by-periods'">
                      <span v-for="(period,i) in job.periods" :key="i">{{ period }} </span>
                    </td>
                    <td>{{ getTimeTaken(job.started_at, job.ended_at) }}</td>
                    <td>{{ job.details }}</td>
                    <td>
                      <button v-if="job.status==='completed'" class="btn btn-info btn-sm"
                              @click="viewJobDetails(index)">Details
                      </button>
                    </td>

                  </tr>
                  </tbody>
                </table>

              </b-card>


              <template v-if="bSort && rSort">

                <b-card>
                  <h4 class="card-title"> Summary </h4>
                  <h5 class="text-muted mb-3" v-if="jobDetails && jobDetails.option ==='filter-by-date-range'">
                    Period: {{ jobDetails.date_range[0] }}
                    -
                    {{ jobDetails.date_range[1] }}</h5>
                  <h5 class="text-muted mb-3" v-if="jobDetails && jobDetails.option ==='filter-by-weeks'">
                    Period: {{ jobDetails.start_date }}
                    -
                    {{ jobDetails.end_date }}</h5>

                  <h5 class="text-muted mb-3" v-if="jobDetails && jobDetails.option ==='filter-by-periods'">
                    Period:
                    <span v-for="(period,i) in jobDetails.periods" :key="i">{{ period }}</span>
                  </h5>
                  <table class="table mt-4">
                    <tr>
                      <td><span class="text-danger">{{ bSort['name'] }} Soort</span></td>
                      <td>{{ bSort['cost_description'] }}</td>
                      <td class="text-right"><span class="font-15 font-weight-bold" id="popover-1">{{ bSort['name'] }} Total = {{
                          bSort['b17sTotal'] | toCurrencyFormat
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="text-danger">{{ rSort['name'] }} Soort</span></td>
                      <td>{{ rSort['cost_description'] }}</td>
                      <td class="text-right"><span class="font-15 font-weight-bold" id="popover-2">{{ rSort['name'] }} Total = {{
                          rSort['costSubTotal'] | toCurrencyFormat
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="text-danger">{{ rSort['name'] }} Soort</span></td>
                      <td>{{ rSort['income_description'] }}</td>
                      <td class="text-right"><span class="font-15 font-weight-bold" id="popover-3">{{ rSort['name'] }} Total = {{
                          rSort['incomeSubTotal'] | toCurrencyFormat
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="text-danger">Grand Total</span></td>
                      <td></td>
                      <td class="text-right"><span class="font-15 font-weight-bold"
                                                   id="popover-4"> Total = {{ grandTotal | toCurrencyFormat }}</span>
                      </td>
                    </tr>
                    <!-- popovers-->
                    <b-popover target="popover-1" triggers="hover" placement="auto">
                      <template #title>BreakDown</template>
                      <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                        <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                          {{ data['bSort']['b17sTotal'] | toCurrencyFormat }}
                        </div>
                      </div>
                      <button @click="downloadData('bSort')" class="btn btn-info btn-sm">Download data</button>
                    </b-popover>


                    <b-popover target="popover-2" triggers="hover" placement="auto">
                      <template #title>BreakDown</template>

                      <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                        <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                          {{ data['rSort']['costSubTotal'] | toCurrencyFormat }}
                        </div>
                      </div>
                      <button @click="downloadData('rSortCost')" class="btn btn-info btn-sm">Download data</button>

                    </b-popover>

                    <b-popover target="popover-3" triggers="hover" placement="auto">
                      <template #title>BreakDown</template>

                      <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                        <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                          {{ data['rSort']['incomeSubTotal'] | toCurrencyFormat }}
                        </div>
                      </div>
                      <button @click="downloadData('rSortIncome')" class="btn btn-info btn-sm">Download data</button>
                    </b-popover>

                    <b-popover target="popover-4" triggers="hover" placement="auto">
                      <template #title>BreakDown</template>
                      <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                        <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                          {{ data['grandTotal'] | toCurrencyFormat }}
                        </div>
                      </div>
                    </b-popover>
                  </table>

                </b-card>

              </template>

              <template v-if="bSort">
                <b-card class="mt-2">
                  <h4 class="card-title">B Soort breakdown</h4>

                  <table class="table mt-2 table-striped">
                    <thead>
                    <tr>
                      <th class="text-left">CDGRBREKENING</th>
                      <th>OMSCHR</th>
                      <th class="text-right">Bedrag</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(sort,ind) in bSort['17s']" :key="ind">
                      <th>{{ sort['CDGRBREKENING'] }}</th>
                      <th>{{ sort['OMSCHR'] }}</th>
                      <th class="text-right">
                        <span :id="'b-17s-popover-'+ind">{{ sort['Bedrag'] | toCurrencyFormat }}</span>
                      </th>
                      <b-popover :target="'b-17s-popover-'+ind" triggers="hover" placement="auto" class="w-100">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ sort['CDGRBREKENING'] }}</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <FAdminCollapse
                              :collapse-id="'fadmin-b17-'+ind"
                              :amount="data['bSort']['b17s'][ind]['Bedrag']"
                              :driver="`${data['driver']['name']} ${data['driver']['other_names']}`"
                              :f-admin-items="data['bSort']['b17s'][ind]['fAdminItems']"
                              :other-info="data['bSort']['b17s'][ind]"
                          />

                        </div>
                      </b-popover>
                    </tr>

                    <tr>
                      <td colspan="3" class="text-right">
                        <span id="17sTotal">belasting en premies sociale |verzekeringen Total: {{
                            bSort['b17sTotal'] | toCurrencyFormat
                          }}</span>
                      </td>
                    </tr>

                    <tr v-for="(sort,ind) in bSort['02s']">
                      <th>{{ sort['CDGRBREKENING'] }}</th>
                      <th>{{ sort['OMSCHR'] }}</th>
                      <th class="text-right"><span
                          :id="'b-02s-data-popover-'+ind">{{ sort['Bedrag'] | toCurrencyFormat }}</span></th>
                      <b-popover :target="'b-02s-data-popover-'+ind" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ sort['CDGRBREKENING'] }}</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <FAdminCollapse
                              :collapse-id="'item-b02s-'+ind"
                              :amount="data['bSort']['b02s'][ind]['Bedrag']"
                              :driver="`${data['driver']['name']} ${data['driver']['other_names']}`"
                              :f-admin-items="data['bSort']['b02s'][ind]['fAdminItems']"
                              :other-info="data['bSort']['b02s'][ind]"
                          />
                        </div>
                      </b-popover>
                    </tr>

                    <tr>
                      <td colspan="3" class="text-right">
                        <span id="02sTotal">overige effecten Total: {{
                            bSort['b02sTotal'] | toCurrencyFormat
                          }}</span>
                      </td>
                    </tr>

                    <tr v-for="(sort,ind) in bSort['14s']">
                      <th>{{ sort['CDGRBREKENING'] }}</th>
                      <th>{{ sort['OMSCHR'] }}</th>
                      <th class="text-right"><span
                          :id="'b-14s-data-popover-'+ind">{{ sort['Bedrag'] | toCurrencyFormat }}</span></th>
                      <b-popover :target="'b-14s-data-popover-'+ind" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ sort['CDGRBREKENING'] }}</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <FAdminCollapse
                              :collapse-id="'item-b14s-'+ind"
                              :amount="data['bSort']['b14s'][ind]['Bedrag']"
                              :driver="`${data['driver']['name']} ${data['driver']['other_names']}`"
                              :f-admin-items="data['bSort']['b14s'][ind]['fAdminItems']"
                              :other-info="data['bSort']['b14s'][ind]"
                          />
                        </div>
                      </b-popover>
                    </tr>

                    <tr>
                      <td colspan="3" class="text-right">
                        <span id="1400">overlopende activa Total: {{ bSort['b14sTotal'] | toCurrencyFormat }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" class="text-right">
                        <span id="b-subTotal">subTotal: {{ bSort['subTotal'] | toCurrencyFormat }}</span>
                      </td>
                      <b-popover target="b-subTotal" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">SubTotal</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                            {{ data['bSort']['subTotal'] | toCurrencyFormat }}
                          </div>
                        </div>
                      </b-popover>
                    </tr>
                    </tbody>
                  </table>
                  <b-card>
                    <button class="btn btn-outline-dark">Generate Bedrijfsvermogen Red Cabs</button>
                  </b-card>
                  <table class="table mt-4">
                    <tr>
                      <td><span class="text-danger">0650</span></td>
                      <td>Bedrijfsvermogen Red Cabs</td>
                      <td class="text-right"><span
                          class="font-15 font-weight-bold">{{ '0.00' | toCurrencyFormat }}</span></td>
                    </tr>
                  </table>

                  <table class="table mt-4">
                    <tr>
                      <td><span class="text-danger">{{ bSort['name'] }} Soort</span></td>
                      <td>{{ bSort['description'] }}</td>
                      <td class="text-right"><span class="font-15 font-weight-bold"
                                                   id="b-sort-sub-total">{{
                          bSort['name']
                        }} Total = {{ bSort['subTotal'] | toCurrencyFormat }}</span>
                      </td>
                      <b-popover target="b-sort-sub-total" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ bSort['name'] }} Total</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                            {{ data['bSort']['subTotal'] | toCurrencyFormat }}
                          </div>
                        </div>
                      </b-popover>
                    </tr>
                  </table>
                </b-card>
              </template>

              <template v-if="rSort">
                <b-card class="mt-2">
                  <h4 class="card-title">R Soort breakdown</h4>
                  <span class="text-danger">{{ rSort['cost_description'] }}</span>
                  <table class="table mt-2 table-striped">
                    <thead>
                    <tr>
                      <th class="text-left">CDGRBREKENING</th>
                      <th>OMSCHR</th>
                      <th class="text-right">Bedrag</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(sort,ind) in rSort['costData']">
                      <th>{{ sort['CDGRBREKENING'] }}</th>
                      <th>{{ sort['OMSCHR'] }}</th>
                      <th class="text-right"><span
                          :id="'r-cost-data-popover-'+ind">{{ sort['Bedrag'] | toCurrencyFormat }}</span></th>
                      <b-popover :target="'r-cost-data-popover-'+ind" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ sort['CDGRBREKENING'] }}</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">

                          <FAdminCollapse
                              :collapse-id="'item-rSort-'+ind"
                              :amount="data['rSort']['costData'][ind]['Bedrag']"
                              :driver="`${data['driver']['name']} ${data['driver']['other_names']}`"
                              :f-admin-items="data['rSort']['costData'][ind]['fAdminItems']"
                              :other-info="data['rSort']['costData'][ind]"
                          />
                        </div>
                      </b-popover>
                    </tr>

                    </tbody>
                  </table>

                  <table class="table mt-4">
                    <tr>
                      <td><span class="text-danger">{{ rSort['name'] }} Soort</span></td>
                      <td>{{ rSort['cost_description'] }} Total</td>
                      <td class="text-right"><span class="font-15 font-weight-bold" id="r-subTotal">{{ rSort['name'] }} Total = {{
                          rSort['costSubTotal'] | toCurrencyFormat
                        }}</span>
                      </td>
                      <b-popover target="r-subTotal" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ rSort['name'] }} Total</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                            {{ data['rSort']['costSubTotal'] | toCurrencyFormat }}
                          </div>
                        </div>
                      </b-popover>
                    </tr>
                  </table>

                </b-card>
                <b-card class="mt-2">
                  <h4 class="card-title">R Soort breakdown</h4>
                  <span class="text-danger">{{ rSort['income_description'] }}</span>
                  <table class="table mt-2 table-striped">
                    <thead>
                    <tr>
                      <th class="text-left">CDGRBREKENING</th>
                      <th>OMSCHR</th>
                      <th class="text-right">Bedrag</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(sort,ind) in rSort['incomeData']">
                      <th>{{ sort['CDGRBREKENING'] }}</th>
                      <th>{{ sort['OMSCHR'] }}</th>
                      <th class="text-right"><span
                          :id="'r-income-data-popover-'+ind">{{ sort['Bedrag'] | toCurrencyFormat }}</span></th>

                      <b-popover :target="'r-income-data-popover-'+ind" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ sort['CDGRBREKENING'] }}</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <FAdminCollapse
                              :collapse-id="'item-rSoort-'+ind"
                              :amount="data['rSort']['incomeData'][ind]['Bedrag']"
                              :driver="`${data['driver']['name']} ${data['driver']['other_names']}`"
                              :f-admin-items="data['rSort']['incomeData'][ind]['fAdminItems']"
                              :other-info="data['rSort']['incomeData'][ind]"
                          />
                        </div>
                      </b-popover>
                    </tr>
                    </tbody>
                  </table>
                  <table class="table mt-4">
                    <tr>
                      <td><span class="text-danger">{{ rSort['name'] }} Soort</span></td>
                      <td>{{ rSort['income_description'] }} Total</td>
                      <td class="text-right"><span class="font-15 font-weight-bold"
                                                   id="r-income-sub-total">{{
                          rSort['name']
                        }} Total = {{ rSort['incomeSubTotal'] | toCurrencyFormat }}</span>
                      </td>
                      <b-popover target="r-income-sub-total" triggers="hover" placement="auto">
                        <template #title>BreakDown</template>
                        <h6 class="mt-0">{{ rSort['name'] }} Total</h6>
                        <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
                          <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
                            {{ data['rSort']['incomeSubTotal'] | toCurrencyFormat }}
                          </div>
                        </div>
                      </b-popover>
                    </tr>
                  </table>
                </b-card>
              </template>


            </template>
          </div>

        </div>
        <!-- card -->
      </div>
      <!-- end Col-9 -->
    </div>

    <!--    popovers-->
    <b-popover v-if="bSort && rSort"
               :target="popOverTarget"
               :show.sync="popoverShow"
               placement="auto"
               container="my-container"
               ref="popover"
    >
      <template #title>
        <b-button class="close" aria-label="Close" @click="popClose">
          <span class="d-inline-block" aria-hidden="true">&times;</span>
        </b-button>
        Breakdown
      </template>
      <div v-for="(data,i) in outputDetails" :key="i" class="mb-1">
        <div>{{ data['driver']['name'] }} {{ data['driver']['other_names'] }} :
          {{ data['bSort']['subTotal'] | toCurrencyFormat }}
        </div>
      </div>
    </b-popover>
    <b-modal
        v-model="showDriverModal"
        size="xl"
        hide-footer
        title="Select Drivers"
        scrollable
    >

      <Sidepanel
          @onDriverSelected="onDriverSelected"
      />

    </b-modal>

  </div>
</template>

<script>

import Sidepanel from "./f-sheet-sidepanel";
import DatePicker from "vue2-datepicker";

import {financialSheetService} from "@/apis/finanical.sheet.service";
import {financialAdministrationService} from "@/apis/financial.administration.service";
import FAdminCollapse from "@/components/FAdminCollapse.vue"

export default {
  name: "generator",
  components: {
    Sidepanel,
    DatePicker,
    FAdminCollapse

  },
  data() {
    return {
      isCollapsed: true,
      visibleDriversCount: 4,
      download_link: '',
      popoverShow: false,
      fAdminDetailsShow: false,
      popOverTarget: 'popover-1',
      selectedOption: 'filter-by-date-range',
      startWeek: '',
      periods: [],
      endWeek: '',
      date_range: [],
      driverList: [],
      outputDetails: [],
      fAdminItems: [],
      bSort: null,
      rSort: null,
      grandTotal: null,
      driver: null,
      financialData: [],
      jobDetails: null,
      jobs: [],
      filterOptions: [
        {value: null, text: '-- Select a filter --'},
        {value: 'first-quarter', text: 'First quarter'},
        {value: 'second-quarter', text: 'Second quarter'},
        {value: 'third-quarter', text: 'Third quarter'},
        {value: 'forth-quarter', text: 'Forth quarter'},
        {value: 'full-year', text: 'Full year'},
        {value: 'clear', text: 'Clear all'}
      ],
      filterSelected: null,
      years: [],
      selectedYear: new Date().getFullYear(),
      downloadOption: 'merge',
      usePeriods: false,
      showDriverModal: false,
      isMobile: window.innerWidth < 768
    }
  },
  computed: {
    // Compute the visible drivers based on the collapse state
    visibleDrivers() {
      return this.isCollapsed
          ? this.driverList.slice(0, this.visibleDriversCount) // Show only the first few drivers
          : this.driverList; // Show all drivers when expanded
    }
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    selectFilterCard() {
      this.usePeriods = false;
      if (this.selectedOption === 'filter-by-date-range') {
        this.startWeek = '';
        this.endWeek = '';
      } else if (this.selectedOption === 'filter-by-weeks') {
        this.date_range = [];
      } else if (this.selectedOption === 'filter-by-periods') {
        this.usePeriods = true;
        this.startWeek = '';
        this.endWeek = '';
        this.date_range = [];
      }

    },
    popOpen(trigger) {
      this.trigger = trigger;
      this.popoverShow = true;
    },
    popClose() {
      this.popoverShow = false;
    },
    removeDate() {
      this.date_range = [];
    },
    downloadData(type) {
      this.$store.dispatch('showLoader')
      const data = {
        output: {
          bSort: {
            name: this.bSort['name'],
            cost_description: this.bSort['cost_description'],
            b17sTotal: this.bSort['b17sTotal']
          },
          rSort: {
            name: this.rSort['name'],
            cost_description: this.rSort['cost_description'],
            costSubTotal: this.rSort['costSubTotal'],
            income_description: this.rSort['income_description'],
            incomeSubTotal: this.rSort['incomeSubTotal']
          }
        },
        output_details: this.outputDetails.map((e) => {
          return {
            driver: e.driver,
            bSort: {
              b17sTotal: e['bSort']['b17sTotal'],
            },
            rSort: {
              costSubTotal: e['rSort']['costSubTotal'],
              incomeSubTotal: e['rSort']['incomeSubTotal'],
            }
          }
        })
      }

      financialSheetService.downloadFinancialComponent({type, data}).then((data) => {
        const {extra} = data
        if (!extra) {
          alert('Error whiles downloading...');
        }
        location.href = this.getFinancialComponentUrl(extra);

      }).finally(() => {
        this.$store.dispatch('hideLoader')
      });

    },

    dateRangeChanged() {
      this.usePeriods = false;
    },

    onFilterPeriodsChanged() {
      if (this.filterSelected === 'first-quarter') {
        this.periods.push(1, 2, 3)
        this.sortPeriods();
      }
      if (this.filterSelected === 'second-quarter') {
        this.periods.push(4, 5, 6)
        this.sortPeriods();
      }
      if (this.filterSelected === 'third-quarter') {
        this.periods.push(7, 8, 9)
        this.sortPeriods();
      }
      if (this.filterSelected === 'forth-quarter') {
        this.periods.push(10, 11, 12)
        this.sortPeriods();
      }
      if (this.filterSelected === 'full-year') {
        this.addAllPeriods();
        this.sortPeriods();
      }
      if (this.filterSelected === 'clear') {
        this.removeAllPeriods();
      }
    },

    sortPeriods() {
      this.periods.sort(function (a, b) {
        return a - b;
      });
    },

    periodTagValidator(tag) {
      try {
        const num = JSON.parse(tag);
        if (isNaN(tag)) {
          return false
        } else if (!Number.isInteger(num)) {
          return false
        } else return !(num < 1 || num > 12);
      } catch (e) {
      }

    },
    addAllPeriods() {
      this.periods = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    },

    removeAllPeriods() {
      this.periods = [];
    },

    getFinancialComponentUrl(token) {
      return process.env.VUE_APP_API_BASE_URL + '/download-financial-component/' + token
    },

    getFAdminDownloadJobProgress(token) {
      this.$store.dispatch('showLoader');
      financialSheetService.fetchFAdminDownloadProgress(token).then(data => {

        if (!data.status) {
          this.$store.dispatch('hideLoader');
          this.$store.dispatch('error', {message: data.message, showSwal: true})
          return;
        }
        this.job = data.extra

        const isJobInProgress = this.job.status === 'in_progress';

        if (isJobInProgress) {
          setTimeout(() => this.getFAdminDownloadJobProgress(token), 5000);
        } else {
          this.$store.dispatch('hideLoader');
          location.href = this.getDownloadUrl(token);

        }
      })
    },


    getDownloadUrl(token) {
      return process.env.VUE_APP_API_BASE_URL + '/download-financial-sheet/' + token
    },

    weekChanged() {
      this.usePeriods = false
    },

    downloadFinancialSheetForDriver(type) {
      if (this.driverList.length < 1) {
        this.$store.dispatch('error', {
          message: 'Please select drivers from the side-panel to proceed.',
          showSwal: true
        })
        return;
      }

      if (this.selectedOption === 'filter-by-date-range' && this.date_range.length === 0) {
        alert('Date range cannot be empty.');
        return;
      }

      if (this.selectedOption === 'filter-by-weeks' && (!this.startWeek || !this.endWeek)) {
        alert('Both start week and end week must be selected.');
        return;
      }

      if (this.selectedOption === 'filter-by-periods' && (this.periods.length === 0 || !this.selectedYear)) {
        alert('Selected year and periods cannot be empty.');
        return;
      }


      const payload = {
        "startWeek": this.startWeek,
        "endWeek": this.endWeek,
        'driverIds': this.driverList.map((e) => e.id),
        'periods': this.periods,
        'year': this.selectedYear,
        'usePeriods': this.usePeriods,
        'date_range': this.date_range,
        'downloadOption': this.downloadOption,
        'option': this.selectedOption,
        'type': type
      }

      this.$store.dispatch('downloadFinancialSheet', payload).then((token) => {
        this.getFAdminDownloadJobProgress(token);
        // location.href = this.getDownloadUrl(token);
      });
    },

    onDriverSelected(drivers, selectAll) {
      if (selectAll) {
        this.driverList = drivers;
      } else {
        if (!drivers) {
          return;
        }
        // this.driver = driver;
        let ind = this.driverList.indexOf(drivers);
        if (ind > -1) {
          this.driverList.splice(ind, 1);
        } else {
          this.driverList.push(drivers);
        }
        this.driverList = [...new Map(this.driverList.map(item => [item.id, item])).values()];
      }
    },

    generateFinancialSheet() {

      if (this.driverList.length < 1) {
        this.$store.dispatch('error', {
          message: 'Please select drivers from the side-panel to proceed.',
          showSwal: true
        })
        return;
      }

      if (this.selectedOption === 'filter-by-date-range' && this.date_range.length === 0) {
        alert('Date range cannot be empty.');
        return;
      }

      if (this.selectedOption === 'filter-by-weeks' && (!this.startWeek || !this.endWeek)) {
        alert('Both start week and end week must be selected.');
        return;
      }

      if (this.selectedOption === 'filter-by-periods' && (this.periods.length === 0 || !this.selectedYear)) {
        alert('Selected year and periods cannot be empty.');
        return;
      }


      const payload = {
        'start-week': this.startWeek,
        'end-week': this.endWeek,
        'periods': this.periods,
        'usePeriods': this.usePeriods,
        'year': this.selectedYear,
        'date_range': this.date_range,
        'drivers': this.driverList.map(driver => ({
          id: driver.id,
          name: driver.name,
          other_names: driver.name,
          dossier: driver.driver?.dossier || null
        })),
        'option': this.selectedOption,
      }
      this.$store.dispatch('generateFinancialSheet', payload).then(() => {
        this.fetchJobProgress();
      })
    },
    getYears() {
      const startYear = 2018;
      const currentYear = new Date().getFullYear();
      const endYear = currentYear + 7;
      this.years = Array.from({length: endYear - startYear + 1}, (_, i) => startYear + i);
    },

    fetchJobProgress() {
      financialAdministrationService.getFinancialSheetJobs().then(data => {
        if (!data.status) {
          this.$store.dispatch('error', {message: data.message, showSwal: true})
          return;
        }
        this.jobs = data.extra

        const isJobInProgress = this.jobs.some(job => job.status === 'in_progress');

        if (isJobInProgress) {
          setTimeout(() => this.fetchJobProgress(), 10000);
        }
      })
    },

    getTimeTaken(start, end) {
      if (!start || !end) return 'N/A';

      const startTime = new Date(start);
      const endTime = new Date(end);
      const diffMs = endTime - startTime;

      if (diffMs < 0) return 'Invalid range';

      const seconds = Math.floor((diffMs / 1000) % 60);
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
      const hours = Math.floor(diffMs / (1000 * 60 * 60));

      return `${hours}h ${minutes}m ${seconds}s`;
    },

    viewJobDetails(jobIndex) {
      const job = this.jobs[jobIndex];

      const data = JSON.parse(job['output']);
      const outputDetails = JSON.parse(job['output_details']);

      this.financialData = data;
      this.jobDetails = {
        option: job.option,
        start_week: job.start_week,
        end_week: job.end_week,
        periods: job.periods,
        date_range: job.date_range,
        year: job.year
      };


      this.bSort = data['bSort'];
      this.rSort = data['rSort'];
      this.grandTotal = data['grandTotal'];
      this.outputDetails = outputDetails;

    },
  },
  watch: {
    usePeriods: function (value) {
      if (!value) {
        this.removeAllPeriods();
      }
    },
  },
  created() {
    this.$store.dispatch('setPageTitle', 'Drivers financial sheet')
    this.getYears();
    this.fetchJobProgress();
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
}
</script>

<style scoped>
.line-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.popover {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
